import React from "react"
import { useEffect } from 'react';


import Footer2 from "../components/Footer2";
import NavbarWorks from "../components/NavbarWorks";
import data from '../data/menu_projects';
import { LazyLoadImage } from 'react-lazy-load-image-component';


//projects import

export default function Projects() {

    // < !-- < body className="film-template-default single single-film postid-653 is-loaded" style = "background-color:#0a0202;--color-base:#0a0202;color:#ffffff;--color-contrast:#ffffff;" data - cursor="pointer" > -->

    function getWindowDimensions() {
        console.log(window.innerWidth)

        return window.innerWidth
    }



    useEffect(() => {
        document.body.classList.add('film-template-default');
        document.body.classList.add('single');
        document.body.classList.add('single-film');
        document.body.classList.add('postid-653');
        document.body.classList.add('is-loaded');

        return () => {
            // document.body.classList.remove('home');
            // document.body.classList.remove('page-template-default');
            // document.body.classList.remove('page');
            // document.body.classList.remove('page-id-2');
            // document.body.classList.remove('page-startseite');
        };


    }, []);



  return (
    <React.Fragment>

        { /* <div style={{backgroundColor: "#094436"}} className="is-snap"> */ }

        { /* <div className="Cursor js-cursor is-visible" style={{ left: '430px', top: '879px' }} ><i></i></div> */ }

        <NavbarWorks />


        <main class = "Film" >

    
            {/* <video class="Film-entryGraphicVideo" loop autoPlay muted playsinline>
                                    <source src={data[0].video} type="video/mp4"/>
                                </video> */} 


        {data.map((data) => (
        //   <li key={season.id}>{season}</li>

            <article class="Film-entry js-filmEntry">
                <a href={'/project/' + data.id}></a>
                    <div class="Film-entryGraphic">
                        <div class="Film-entryGraphicTitle"></div>
                    
                        <LazyLoadImage
                                        width="2560" height="1698"
                                        src={data.image}
                                        alt=""
                                    />
                    </div>
                    <h2 class="Film-entryTitle"><span>{data.title}</span></h2>
            </article> 
          
        ))}
        
        
        </main>






        <Footer2 />


    </React.Fragment >
  );
}

